import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import applyFormat from '../functions/applyFormat';
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditRollingBonusModal = () => {
    // get context from parent
    const {
        editRollingBonusModal, 
        setEditRollingBonusModal, 
        editRollingBonusRow, 
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        rollingBonusEditConfig, 
        rollingBonusLists
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST, 
        PUT, 
    } = useContext(HttpContext);
    // initialize state
    const [values, setValues] = useState([]); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    const [statusChange, setStatusChange] = useState(false); 

    // event handler for values change 
    const onInputChange = () => {
        // determine if status has changed 
        if (values.active?.id.toString() !== editRollingBonusRow.active?.toString()) {
            setStatusChange(statusChange => statusChange = true); 
        }
        else {
            setStatusChange(statusChange => statusChange = false); 
        } 
    }

    // event handler for submit button click
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            if (!statusChange) {
                let requestValues = [{...values}]; 
                // validate input
                let checkError = validateInputArray(
                    requestValues, 
                    rollingBonusEditConfig,
                    dynamicValidation,
                    rollingBonusLists, 
                    snackbarAlert,  
                    error, 
                    setError, 
                    dynamicTransformation, 
                    {}
                ); 
                // exit request if error 
                if (checkError) {
                    reject(); 
                    return; 
                }
                // add mastercompanyid to request body 
                requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid'];
                // get oldValues to attach to request 
                let temp = {...editRollingBonusRow}
                let oldValues = applyFormat(temp, rollingBonusEditConfig, rollingBonusLists, null); 
                oldValues = dynamicTransformation(oldValues, rollingBonusEditConfig, {}); 
                // make post request 
                let response; 
                PUT('/client/rollingBonus', {
                    ...requestValues[0], 
                    oldValues: oldValues
                }).then(res => {
                    console.log(res);
                    response = res; 
                    // hide modal on success
                    setEditRollingBonusModal(editRollingBonusModal => editRollingBonusModal = false);
                    // trigger success alert
                    snackbarAlert(true, 'Successfully uploaded data.', 'success');
                    // refresh CompanyDetailsPage using function from parent
                    return getRefreshData();
                }).then(res => {
                    console.log(res); 
                    // resolve on success
                    resolve(response); 
                }).catch(err => {
                    console.log(err);
                    // show alert on error
                    snackbarAlert(true, 'Error uploading data.', 'error');
                    // reject on error
                    reject(err); 
                });
            }
            else {
                // validate status input 
                if (!rollingBonusLists['active'].includes(values['active'])){
                    // show snackbar on failure
                    snackbarAlert(true, 'Invalid status input.', 'error'); 
                    reject(); 
                    return; 
                }
                // make PUT request 
                let response; 
                PUT('/client/incentiveSetupStatus', {
                    active: values['active']['id'], 
                    incentivesetupid: values['incentivesetupid'], 
                    mastercompanyid: masterCompanyData['mastercompanyid'], 
                    companyid: values['companyid'], 
                    oldValues: {
                        active: editRollingBonusRow['active']
                    }
                }).then(res => {
                    console.log(res);
                    response = res;
                    // hide modal on success
                    setEditRollingBonusModal(editRollingBonusModal => editRollingBonusModal = false);
                    // trigger success alert
                    snackbarAlert(true, 'Successfully uploaded data.', 'success');
                    // refresh CompanyDetailsPage using function from parent
                    return getRefreshData();
                }).then(res => {
                    console.log(res); 
                    // resolve on success
                    resolve(response); 
                }).catch(err => {
                    console.log(err);
                    // show alert on error
                    snackbarAlert(true, 'Error uploading data.', 'error');
                    // reject on error
                    reject(err); 
                });
            }
        });         
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (rollingBonusEditConfig){
            setConfig(config => config = rollingBonusEditConfig); 
        }
    }, [rollingBonusEditConfig]); 

    // useEffect to run on editRollingBonusRow change
    useEffect(() => {
        if (editRollingBonusRow) {
            // add ids to lookup values 
            let temp = {
                ...editRollingBonusRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, rollingBonusEditConfig, rollingBonusLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editRollingBonusRow]); 

    // useEffect for value change
    useEffect(() => {
        onInputChange(); 
    }, [values]); 

    return(
        <> 
            <CCOffcanvas
                title = { `Edit Setup ID: ${editRollingBonusRow['incentivesetupid']}`}
                onCanvasClose={()=>setEditRollingBonusModal(editRollingBonusModal => editRollingBonusModal = false)}
                show={editRollingBonusModal}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* map DynamicPageInput over all elements of input config */}
                        {config.map((el) => 
                            el['edit'] == true &&
                            (!statusChange || el['columnid'] == 'active') ? 
                            <>
                                <div>
                                    <DynamicPageInput 
                                        data={values} 
                                        setData={setValues} 
                                        config={el} 
                                        args={rollingBonusLists} 
                                        width={'100%'} 
                                        showError={error[0][el['columnid']]}
                                        topAlignTypography={true}
                                    />
                                </div>
                            </>
                            : <></>
                        )}
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        {/* button to submit edits to rebate setup */}
                        <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setEditRollingBonusModal(editRollingBonusModal => editRollingBonusModal = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditRollingBonusModal; 